module.exports = __webpack_public_path__ + "media/images/icons/danger-c4b4cb9e3bd63c063491f9aa3bc9b05b.svg";